import { features } from "app/features";
import { useIsRedesign } from "pages/redesign/preferences/redesignUtils";
import React from "react";
import { GenericNotification } from "./GenericNotification";
import useCookie from "react-use-cookie";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setPreference } from "pages/preferences/preferencesActions";
import { REDESIGN, REDESIGN_REMINDER } from "redux/slices/api/initialisePreferences";
import { _t } from "app/i18n/i18n";
import { BASENAME, isPublicPath } from "lib/routing";
import { auditSwitchToRedesign } from "lib/analytics/auditEvents";

export const RedesignReminder = () => {
  const isRedesign = useIsRedesign();
  const [isDismissed, setDissmissed] = useCookie(REDESIGN_REMINDER, false);
  if (!features.showRedesignReminder || isRedesign || isDismissed || isPublicPath()) return null;

  return <GenericNotification {...getRedesignReminder()} buttons={<Buttons setDissmissed={setDissmissed} />} />;
};

const Buttons = ({ setDissmissed }) => {
  const dispatch = useDispatch();

  const onDismiss = () => setDissmissed(true, { days: 5 });

  const onSwitchToRedesign = () => {
    setDissmissed(true, { days: 5 });
    dispatch(setPreference({ key: REDESIGN, value: "New" },true));
    
    auditSwitchToRedesign(true);    
    document.location.href = BASENAME + "/Home";
  };

  return (
    <>
      <Button onClick={onDismiss} variant="outline-secondary mx-1">
        {_t("Dismiss")}
      </Button>
      <Button onClick={onSwitchToRedesign} variant="success mx-1">
        {_t("New Menu Design")}
      </Button>
    </>
  );
};

// imported by miscSlice notification initial state.
export const getRedesignReminder = () => ({
  id: "switch to redesign",
  type: "redesignReminder",
  header: _t("New Menu Design"),
  body: _t("Use the new menu design and search bar"),
  bg: "bg-secondary",
  icon: "fas fa-rocket",
  className: "maxw-400",
});
